import { Controller } from "@hotwired/stimulus"

// The P&L statement's product picker: a searchable list of checkboxes inside a dropdown. Nothing
// is sent until Apply (the checkboxes belong to the surrounding filter form). Search narrows the
// list, and Select all / Unselect all act on what is showing, so "search shaker, select all"
// picks every shaker. Nothing selected, or everything selected, means all products, and then no
// products are sent at all so the URL stays clean. With no products in the URL the picker opens
// with every box ticked, so it always shows what the table is showing.
export default class extends Controller {
  static targets = ["search", "item", "summary", "count", "none"]
  static values = { total: Number }

  connect() {
    this.form = this.element.closest("form")
    this.beforeSubmit = () => {
      if (this.checked().length === this.totalValue) this.setChecked(this.itemTargets, false)
    }
    this.form?.addEventListener("submit", this.beforeSubmit)
    this.update()
  }

  disconnect() {
    this.form?.removeEventListener("submit", this.beforeSubmit)
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    let visible = 0
    this.itemTargets.forEach((item) => {
      const match = !query || item.dataset.search.includes(query)
      item.hidden = !match
      if (match) visible += 1
    })
    this.noneTarget.classList.toggle("d-none", visible > 0)
    this.update()
  }

  selectVisible() {
    this.setChecked(this.itemTargets.filter((item) => !item.hidden), true)
    this.update()
  }

  clear() {
    this.setChecked(this.itemTargets, false)
    this.update()
  }

  changed() {
    this.update()
  }

  preventSubmit(event) {
    event.preventDefault()
  }

  update() {
    const checked = this.checked()
    const visible = this.itemTargets.filter((item) => !item.hidden).length
    const everything = checked.length === 0 || checked.length === this.totalValue

    let label = "All products"
    if (!everything) {
      label = checked.length === 1
        ? checked[0].closest("li").querySelector(".st-product-title").textContent.trim()
        : `${checked.length} products`
    }
    this.summaryTarget.textContent = label
    this.countTarget.textContent = `${checked.length} selected · ${visible} showing`
  }

  checked() {
    return this.itemTargets.map((item) => item.querySelector("input")).filter((input) => input.checked)
  }

  setChecked(items, value) {
    items.forEach((item) => { item.querySelector("input").checked = value })
  }
}
